// extracted by mini-css-extract-plugin
module.exports = {"photolist":"PhotoList_photolist__NZl5d","photo":"PhotoList_photo__1qLvH","details":"PhotoList_details__iZs2c","profile":"PhotoList_profile__2mtTb"};